// extracted by mini-css-extract-plugin
module.exports = {"header":"SurveyHeader_header__FC4Nu","logo":"SurveyHeader_logo__Q1_oP"};